












































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import {
  GetTeacherList,
  EditTeacher,
  DelTeacher,
  ResetPassword,
  GetZiliaobaoList,
  ImportZiliaobao,
} from "@/request/common";
@Component({
  components: {
    Header,
    LeftNav,
  },
})
export default class Name extends mixins(listMixin) {
  private ifShowEdit: any = false;
  private ifShowImport: any = false;
  private currentUser: any = {};
  private ziliaobaos: any = [];
  private data: any = [];
  private editData: any = {
    授权产品: [],
  };
  private ziyuanData: any = {
    题目类别: [],
    导入模块: [],
    导入模式: "覆盖",
  };
  private importModules: string[] = [];
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private getText(arr: any) {
    let text = "";
    if (arr && arr.length > 0) {
      arr.forEach((ele: any, index: any) => {
        if (index !== 0) {
          text += "、";
        }
        text += ele["名称"];
      });
    }
    return text;
  }
  private selectZiliaobao(item: any) {
    item.selected = !item.selected;
    this.$forceUpdate();
  }
  private importSure() {
    let d: any = [];
    this.ziliaobaos.forEach((ele: any) => {
      if (ele.selected) {
        d.push(ele.ziyuan_group_id);
      }
    });
    if (d.length === 0) {
      this.$message.warning("请选择需要导入的资料包");
      return;
    }
    const params: any = {
      teacher_id: this.currentUser.user_id,
      zg_ids: d,
    };
    if (this.ziyuanData["题目类别"].length > 0) {
      params["题目类别"] = this.ziyuanData["题目类别"];
    }
    if (this.ziyuanData["导入模块"].length > 0) {
      params["导入模块"] = this.ziyuanData["导入模块"];
    }
    if (this.ziyuanData["导入模式"]) {
      params["导入模式"] = this.ziyuanData["导入模式"];
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    ImportZiliaobao(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("导入成功");
        this.ifShowImport = false;
        this.getList();
      })
      .catch(() => {
        loading.close();
      });
  }
  private openImport(item: any) {
    this.currentUser = item;
    GetZiliaobaoList(this).then((res: any) => {
      this.ziliaobaos = res;
      this.ziliaobaos.forEach((ele: any) => {
        ele.selected = false;
      });
      this.ifShowImport = true;
    });
  }
  private openEditUser(item?: any) {
    this.ifShowEdit = true;
    if (item) {
      if (!item["产品权限"]) {
        item["产品权限"] = [];
        this.$forceUpdate();
      }
      this.editData = JSON.parse(JSON.stringify(item));
    } else {
      this.editData = {
        最大学生数量: "30",
        产品权限: [],
      };
    }
  }
  private editUser() {
    if (!this.editData["账户名"]) {
      this.$message.warning("请输入账户名");
      return;
    }
    if (this.editData["手机号"]) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.editData["手机号"])) {
        this.$message.warning("手机号格式不正确");
        return;
      }
    }
    if (this.editData["产品权限"].length == 0) {
      this.$message.warning("请选择授权产品");
      return;
    }
    if (!this.editData["最大学生数量"]) {
      this.$message.warning("请输入学生账户数量");
      return;
    }

    if (!this.editData["交付状态"]) {
      this.$message.warning("请选择账户属性");
      return;
    }
    if (!this.editData["状态"]) {
      this.$message.warning("请选择状态");
      return;
    }
    const regex = /^[\a-\z\A-\Z0-9\u4e00-\u9fe5]+$/;
    if (!regex.test(this.editData["账户名"])) {
      this.$message.warning("账户名只能输入中文、英文、数字");
      return;
    }
    if (this.editData["最大学生数量"] < this.editData["下属学生数量"]) {
      this.$message.warning("学生账户数量上限不能小于当前实际学生账户数量");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    EditTeacher(this, this.editData, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("保存成功");
        this.ifShowEdit = false;
        this.getList();
      })
      .catch(() => {
        loading.close();
      });
  }
  private deleteOne(item: any) {
    this.$confirm("您确定要删除该数据么？", "删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    })
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
          data: {
            user_id: item.user_id,
          },
        };
        DelTeacher(this, params, loading)
          .then((res: any) => {
            loading.close();
            this.$message.success("删除成功");
            if (this.data.length === 1 && this.filters.current_page !== 1) {
              this.filters.current_page--;
            }
            this.getList();
          })
          .catch(() => {
            loading.close();
            this.$message.success("删除成功");
            this.getList();
          });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  private banApply(item: any) {
    const type: any = item["状态"] == "禁用" ? "启用" : "禁用";
    this.$confirm("您确定要" + type + "该账号么？", type, {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      item["状态"] = item["状态"] == "禁用" ? "正常" : "禁用";
      EditTeacher(this, item, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success(type + "成功");
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private resetPaw(item: any) {
    this.$confirm("您确定要重置密码么？", "重置密码", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        user_id: item.user_id,
      };
      ResetPassword(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("重置密码成功");
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      search: this.filters.search,
      交付状态: this.filters["属性"],
      状态: this.filters["状态"],
      order_key: this.filters.sort_field,
      order_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    GetTeacherList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.filters.sort_field = "update_time";
    this.getList();
  }
}
